import React from 'react';

const IconFolder = () => (
  <svg xmlns="http://www.w3.org/2000/svg" role="img" fill="#8892b0" viewBox="0 0 28 28" stroke="currentcolor" strokeWidth="0.2" strokeLinecap="round" strokeLinejoin="round">
    <title>Folder</title>
    <path
      d="M11 5h13v17h-24v-20h8l3 3zm-10-2v18h22v-15h-12.414l-3-3h-6.586z"
    />
  </svg>
);

export default IconFolder;
